<div>
  <br>
  <br>

  <app-pec-lists [withFilter]="withFilter" [withSearchBar]="withSearchBar" [viewMode]="viewMode" [addButton]="addButton"></app-pec-lists>

</div>